import { Alert, AlertDescription, AlertTitle } from '@ophelos/ui/components/alert';
import { CircleAlert } from 'lucide-react';
import { useConfiguration } from '@/contexts/ConfigurationContext';
import { useTranslation } from '@/hooks/useTranslation';

/** Renders nothing unless the client's content config carries an FCA firm reference number. */
export function AffordabilityCommitment() {
  const { config } = useConfiguration();
  const { t } = useTranslation();

  // `journey.budget_assessment.enabled` is the real UK/non-UK switch, but Connect's
  // `_CUSTOMER_VISIBLE_JOURNEY_KEYS` allowlist withholds `budget_assessment` from the browser, so the
  // FRN is the nearest equivalent signal the portal can see. Named so that widening that allowlist
  // surfaces this consumer — otherwise the switch becomes available and nothing points here.
  if (!config.ui?.companyInfo?.fcaFrn?.trim()) return null;

  return (
    <Alert variant="subtle" className="max-w-sm mx-auto mt-auto">
      <CircleAlert />
      <AlertTitle>{t('paymentTabs.affordability.title')}</AlertTitle>
      <AlertDescription>
        <ul className="list-disc pl-5 space-y-1">
          <li>{t('paymentTabs.affordability.point1')}</li>
          <li>{t('paymentTabs.affordability.point2')}</li>
          <li>{t('paymentTabs.affordability.point3')}</li>
        </ul>
      </AlertDescription>
    </Alert>
  );
}
